import { Component, OnInit } from '@angular/core';
import { HttpserviceService } from '../../service/http.service.service';
import { Router } from '@angular/router';
import { UtilsService } from '../../service/utils.service';
import { GlobalConfig } from '../../entities/global-config';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs/Subject';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ChartsModule } from 'ng2-charts';
import { Daterangepicker } from 'ng2-daterangepicker';
import { DaterangepickerConfig } from 'ng2-daterangepicker';
import { DatePipe } from '@angular/common';

declare var moment: any;
  
@Component({
  selector: 'app-main-dashboard',
  templateUrl: './main-dashboard.component.html',
  styleUrls: ['./main-dashboard.component.css']
})
export class MainProjectDashboardComponent implements OnInit {
  isDeveloper: Boolean = false;
  developers: any[] = [];
  isShow: Boolean = false;
  agentId: any = '';
  isList: Boolean = true;
  isProject: Boolean = true;
  public mainInput = {
    start: moment().subtract(1, 'month'),
    end: moment().subtract(0, 'month')
  };

  public singlePicker = {
    minDate: moment().subtract(120, 'month'),
    maxDate: moment().add(12, 'month'),
    daterangepicker: true,
    showDropdowns: true,
    opens: 'left',
  };

  public singleDate: any;
  public eventLog = '';

  constructor(
    private servicesComponent: HttpserviceService,
    private router: Router,
    private utilsService: UtilsService,
    private config: GlobalConfig,
    private toastr: ToastsManager,
    private modalService: BsModalService,
    private daterangepickerOptions: DaterangepickerConfig
  ) {
    this.daterangepickerOptions.settings = {
      locale: { format: 'YYYY-MM-DD' },
      alwaysShowCalendars: false,
      ranges: {
        'Last Month': [moment().subtract(1, 'month'), moment()],
        'Last 3 Months': [moment().subtract(4, 'month'), moment()],
        'Last 6 Months': [moment().subtract(6, 'month'), moment()],
        'Last 12 Months': [moment().subtract(12, 'month'), moment()],
      }
    };
    this.singleDate = Date.now();
  }

  bsModalRef: BsModalRef;
  totalItems: any = Number;
  viewsCount: any[] = [];
  totalpropertyImpressionsAll: 0;
  totalpropertyPageViewsAll: 0;
  totalLeadsDeliveredAll: 0;
  agents: any[] = [];
  page: any = { pageNumber: 1, pageSize: 20, agentId: 0, startDate: this.mainInput.start, endDate: this.mainInput.end, isProject : true };
  ngOnInit() {
    const roles = localStorage.getItem("role");
    this.setPermissions(roles);
    this.GetDevelopers();
    this.getDashboard();
  }
  setPermissions(roles) {
    const userId = Number(JSON.parse(localStorage.getItem("profile")).nameid);
    const data = this;
    if (roles != null) {
      const roleName = roles.split(",");
      roleName.forEach(function (value) {
        switch (value) {
          case "agents":
            data.agentId = userId;
            data.isDeveloper = true;
            break;

          default:
            break;
        }

      });
    }
  }

  getDashboard() {
    if (this.agentId > 0) {
      this.page.agentId = this.agentId;
    }
    this.servicesComponent.getDashboard(this.page)
      .then((response: any) => {
        if (response.success) {
          this.viewsCount = response.receiveObj.result.data;
          this.totalItems = response.receiveObj.result.total_rows;
          this.totalpropertyImpressionsAll = response.receiveObj.result.total_impression;
          this.totalpropertyPageViewsAll = response.receiveObj.result.total_views;
          this.totalLeadsDeliveredAll = response.receiveObj.result.total_leads;
          //this.getLabelTotalCounts(this.viewsCount);
          this.isShow = true;
          this.isList = this.viewsCount.length > 0 ? true : false;
        } 
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  getLabelTotalCounts(list: any) {
    this.totalpropertyImpressionsAll = 0;
    this.totalpropertyPageViewsAll = 0;
    this.totalLeadsDeliveredAll = 0;
    if (list.length > 0) {
      list.forEach(element => {
        this.totalpropertyImpressionsAll = this.totalpropertyImpressionsAll + element.propertyImpression;
        this.totalpropertyPageViewsAll = this.totalpropertyPageViewsAll + element.propertyPageView;
        this.totalLeadsDeliveredAll = this.totalLeadsDeliveredAll + element.leads;
      });
    }
  }

  GetDevelopers() {
    this.servicesComponent.GetDevelopers()
      .then((response: any) => {
        if (response.success) {
          this.developers = response.receiveObj;
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  pageChanged(event: any): void {
    this.page.pageNumber = event.page;
    this.page.pageSize = event.itemsPerPage;
    this.getDashboard();
  }

  searchviewsCount() {
    this.page.pageNumber = 1;
    this.getDashboard();
  }

  private selectedDate(value: any, dateInput: any) {
    dateInput.start = value.start;
    dateInput.end = value.end;
    var datePipe = new DatePipe('en-US');
    this.page.startDate = datePipe.transform(dateInput.start, 'yyyy-MM-dd');
    this.page.endDate = datePipe.transform(dateInput.end, 'yyyy-MM-dd');
    this.searchviewsCount();
  }

  private singleSelect(value: any) {
    this.singleDate = value.start;
  }

  private applyDate(value: any, dateInput: any) {

    dateInput.start = value.start;
    dateInput.end = value.end;
  }

  public calendarEventsHandler(e: any) {
    this.eventLog += '\nEvent Fired: ' + e.event.type;
  }

}




// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/DubaisaleV1/cpapi.v1/CPDubaisaleApp/src/app/mainProjectDashboard/main-dashboard/main-dashboard.component.ts